import Box from "@mui/material/Box";
import Zoom from "@mui/material/Zoom";
import Fab from "@mui/material/Fab";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ScrollToTopButton = () => {
  const trigger = useScrollTrigger({ threshold: 300, disableHysteresis: true });

  const handleClick = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box
        role="presentation"
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: (theme) => theme.zIndex.tooltip + 1,
        }}
      >
        <Fab
          onClick={handleClick}
          sx={{
            bgcolor: "background.paper",
            boxShadow: 4,
            width: 56,
            height: 56,
            borderRadius: "10px",
            fontWeight: 700,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "auto",
            border: "1px solid",
            borderColor: "#54afe2",
            '&:hover': {
              bgcolor: "#54afe2",
              color: "#fff",
            },
          }}
        >
          <KeyboardArrowUpIcon />
          <Box component="span" sx={{ fontSize: 10, fontWeight: 700 }}>
            TOP
          </Box>
        </Fab>
      </Box>
    </Zoom>
  );
};

export default ScrollToTopButton;
